import axios from "axios"
import { ConnectedStoreAddress } from "models/ConnectedStore"
import { AppResponse } from "models/Response"
import { Util } from "Util"

export interface StoreConnectStatus {
  hasStore: boolean
  hasCustomStore: boolean
  hasShopifyStore: boolean
  storeName: string | null
}

export interface StoreJoinResult {
  alreadyLinked: boolean
  storeId?: string
  storeName?: string
  platform: string
  shop: string
  integrationId: string
  session: string
  redirectPath: string
  redirectUrl: string
  /** One-time integration API key (shown only on first create). */
  apiKey?: string | null
}

export class StoreConnectService {
  public static async getStatus(): Promise<AppResponse<StoreConnectStatus>> {
    const ep = Util.apiAuthUrl("integrations/custom/status")
    return axios.get(ep)
  }

  public static async joinStore(payload: {
    storeName: string
    accessKey?: string
    defaultDeliveryMethod?: string
    orderPreparationMinutes?: number
    defaultPickupAddress?: ConnectedStoreAddress
  }): Promise<
    AppResponse<StoreJoinResult> & { error?: string; errorCode?: string }
  > {
    const ep = Util.apiAuthUrl("integrations/custom/join")
    return axios.post(ep, payload)
  }
}
